<template>
  <div>
    <ProjectSettingsParentBar />
    <router-view ></router-view>
  </div>
</template>

<script>
import ProjectSettingsParentBar from "@/components/ProjectSettingsParentBar.component.vue";
export default {
  data(){
    return {
      projectId: this.$route.params.projectId,
    }
  },
  computed: {
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    }
  },
  components: {
    ProjectSettingsParentBar,
  },
  created(){
    if(!this.admins || (this.admins && !this.admins.length)){
      this.$router.push(`/notFound`);
    }
  },
  mounted() {
    this.setProjectId(this.$route.params.projectId);
  },
  methods: {
    setProjectId(projectId) {
      this.$store.commit("markets/setProjectId", {
        projectId: projectId,
      });
    },
  },
};
</script>

<style>
</style>